
/**
 * 
 * @param {*} c 
 * 将上课时间数组格式化成如下形式:
 * "7 月12日 - 8 月29· 周六14: 00 - 15: 00、 周日14: 00 - 15: 30"
 */
export function getPaikePeriod(paikeList) {
    const weekdayArr = [
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
        "周日",
    ];

    let s2, arr = [];

    paikeList.forEach((item) => {
        if (item.startTime && item.endTime) {
            arr.push(
                weekdayArr[item.weekday - 1] + item.startTime + "-" + item.endTime
            );    
        }
    });
    s2 = arr.join("、");

    return s2;
}


